'use client';

import { Toaster as SonnerPrimitive } from 'sonner';

export function SonnerToaster() {
  return (
    <SonnerPrimitive
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            'group toast bg-background text-foreground border-border shadow-lg ring-1 ring-inset rounded-xl',
          description: 'text-muted-foreground mt-1 leading-relaxed text-sm',
          actionButton:
            'bg-primary text-primary-foreground rounded-md px-3 py-2 text-sm font-medium transition-colors',
          cancelButton:
            'bg-muted text-muted-foreground rounded-md px-3 py-2 text-sm font-medium transition-colors',
          title: 'text-sm font-bold flex items-center gap-x-1.5',
          icon: 'flex-shrink-0 w-5 h-5',
          success:
            'bg-green-50 text-green-900 border-green-700 ring-green-700 ring-opacity-5',
          error:
            'bg-red-50 text-red-900 border-red-700 ring-red-700 ring-opacity-5',
          warning:
            'bg-amber-50 text-amber-900 border-amber-700 ring-amber-700 ring-opacity-5',
          info: 'bg-blue-50 text-blue-900 border-blue-700 ring-blue-700 ring-opacity-5',
        },
      }}
    />
  );
}
